import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { ThemeSliceState } from '../store/themeSlice';

export const useAppWithThemeSelector: TypedUseSelectorHook<ThemeSliceState> = useSelector;
export const useAppWithThemeDispatch: () => ThunkDispatch<ThemeSliceState, void, Action> = useDispatch;
